import { FunctionComponent, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import CanPower from '../canPower';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFPhone from '@/components/UI/svg/LandingPage/EFPhone';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFCoffeeMaker from '@/components/UI/svg/LandingPage/EFCoffeeMaker';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';

const { EFPic } = createEFPic('/img/landingPage/');
interface PropsType {
    id: string;
}
const LINK_MAP: any = {
    za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station',
    sa: 'https://www.amazon.ae/dp/B0B45YZ2F2?ref=myi_title_dp',
    // au: 'https://au.ecoflow.com/products/delta-pro-portable-power-station',
};
const DeltaProKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const canPowerList = [
        {
            name: t('secF_Light'),
            times: `4 ${t('secF_days')}`,
            icon: <EFLight />,
        },
        {
            name: t('secF_WiFiRouter'),
            times: `108 ${t('secF_hrs')}`,
            icon: <EFWifiRouter />,
        },
        {
            name: t('secF_phone'),
            times: `313 ${t('secF_times')}`,
            icon: <EFPhone />,
        },
        {
            name: t('secF_laptop'),
            times: `57 ${t('secF_times')}`,
            icon: <EFLaptop />,
        },
        {
            name: t('secF_Refrigerator'),
            times: `1-2 ${t('secF_days')}`,
            icon: <EFRefrigerator />,
        },
        {
            name: t('secF_ElectricHeater'),
            times: `1.5 ${t('secF_hrs')}`,
            icon: <EFElectricHeater />,
        },
        {
            name: t('secF_Microwave'),
            times: `2.5 ${t('secF_hrs')}`,
            icon: <EFMicroware />,
        },
        {
            name: t('secF_ElectricKettle'),
            times: `2.2 ${t('secF_hrs')}`,
            icon: <EFElectricKettle />,
        },
        {
            name: t('secF_CoffeeMaker'),
            times: `3.3 ${t('secF_hrs')}`,
            icon: <EFCoffeeMaker />,
        },
        {
            name: t('secF_AirConditioner'),
            times: `1.8-3.6 ${t('secF_hrs')}`,
            icon: <EFAirConditioner />,
        },
    ];

    const buyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('ts_bundle_delta_pro_2'),
                position: `Solution Page_${t('ts_bundle_delta_pro_1')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(LINK_MAP[locale]);
    };

    return (
        <div className={css.deltaProKit} id={props.id}>
            <div className="content">
                <div className="swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-swiper starterkit-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={true}
                        loop
                        speed={800}
                        spaceBetween={10}
                        centeredSlides={true}
                    >
                        <SwiperSlide>
                            <div className="img-box">
                                <EFPic
                                    name={
                                        locale === 'za'
                                            ? ['product/bundle_delta_pro_ts_za.webp', 'product/bundle_delta_pro_ts_za.png']
                                            : ['product/bundle_delta_pro_ts.webp', 'product/bundle_delta_pro_ts.png']
                                    }
                                    alt={t('ts_bundle_delta_pro_1')}
                                />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img-box">
                                <EFPic name={['bundle_delta_pro.webp', 'bundle_delta_pro.jpg']} alt={t('ts_bundle_delta_pro_1')} />
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="info-box">
                    <div className="name">{t('ts_bundle_delta_pro_1')}</div>
                    <div className="device">{t('ts_bundle_delta_pro_2')}</div>
                    <div className="power">
                        {t.rich('ts_bundle_delta_pro_3', {
                            p: (child: ReactNode) => <p>{`- ${child}`} </p>,
                        })}
                    </div>
                    <div className="desc">{t('ts_bundle_delta_pro_4')}</div>
                </div>
                {LINK_MAP[locale] && (
                    <div className="buy-box">
                        <div className="buy-btn" onClick={() => buyNow()}>
                            {locale === 'au' ? t('learn_more') : t('secF_buyNow')}
                        </div>
                        <p className="buy-desc">{t('ts_bundle_delta_pro_tip')}</p>
                    </div>
                )}
                {locale !== 'au' && <CanPower list={canPowerList} />}
            </div>
        </div>
    );
};

export default DeltaProKit;
